import * as Yup from 'yup';
import phoneNumber from '../../schemas/phoneNumber';

export default Yup.object({
  address: Yup.string()
    .required('L\'indirizzo è obbligatorio'),
  company: Yup.string()
    .required('La ragione sociale è obbligatoria'),
  contactName: Yup.string()
    .required('Il nome è obbligatorio'),
  phoneNumber: Yup.string()
    .required('Il recapito telefonico è necessario')
    .concat(phoneNumber),
  email: Yup.string()
    .email('Il formato dell\'email non è valido'),
});
